export const DEPARTMENTS_FEATURE_KEY = 'departments';
